/**
 * @packageDocumentation
 * @module      pdoData.ts
 * @description Bundles the PDO related EMC data
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
export default class PdoData {
    constructor() {
        this.ic = new Ic();
        this.sc = new Sc();
        this.rc = new Rc();
        this.ui = new Ui();
    }
    static fromJSON(json) {
        if (json) {
            let pdoData = new PdoData();
            pdoData.ic = Ic.fromJSON(json);
            pdoData.sc = Sc.fromJSON(json);
            pdoData.rc = Rc.fromJSON(json);
            pdoData.ui = Ui.fromJSON(json);
            return pdoData;
        }
        return null;
    }
}
export class subSystemCpuMem {
    constructor() {
        this.cpuUsage = 0;
        this.memoryUsage = 0;
    }
    static createFromJSON(json, key) {
        var _a, _b, _c, _d;
        const data = new this();
        ;
        data.cpuUsage = ((_b = (_a = json.Cpu) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.cpuUsage) || 0;
        data.memoryUsage = ((_d = (_c = json.Cpu) === null || _c === void 0 ? void 0 : _c[key]) === null || _d === void 0 ? void 0 : _d.memoryUsage) || 0;
        return data;
    }
}
export class Ic extends subSystemCpuMem {
    static fromJSON(json) {
        return this.createFromJSON(json, "IC");
    }
}
export class Sc extends subSystemCpuMem {
    static fromJSON(json) {
        return this.createFromJSON(json, "SC");
    }
}
export class Rc extends subSystemCpuMem {
    static fromJSON(json) {
        return this.createFromJSON(json, "RC");
    }
}
export class Ui extends subSystemCpuMem {
    static fromJSON(json) {
        return this.createFromJSON(json, "UI");
    }
}
//# sourceMappingURL=PdoData.js.map